import React, { useState, useEffect, useContext } from "react";
import './leftDetails.scss';
import { LuMinus } from "react-icons/lu";
import { CgClose } from "react-icons/cg";
import { GoCheck } from "react-icons/go";
import { HiMiniPause } from "react-icons/hi2";
import { use } from "react";
import candidateApi
 from "../../services/candidateApi";
import { toast } from "react-toastify";

export const HiringTimeline = ({candidateId}) => {
  const [jobData, setJobData] = useState(null);
  const [candidateActivity, setCandidateActivity] = useState(null);

  useEffect(() => {
    fetchJobs();
  }, []);

  useEffect(() => {
    if(jobData){
      fetchCandidateActivity(jobData.jobId);
    }
  }, [jobData]);
  
  const fetchJobs = async () => {
    try {
      const response = await candidateApi.getJobsByCandidate(candidateId);
      if (response?.data) {
        setJobData(response.data[0]);
      } 
    } catch (error) {
      toast.error("Error fetching candidate job details", {
                position: "top-right", 
                autoClose: 2000,
              });
      console.error("Error fetching candidate job details:", error);
    }
  };

  const fetchCandidateActivity = async (jobId) => {
    try {
      const response = await candidateApi.getCandidateActivityDetails(candidateId, jobId);
      if (response?.data) {
        setCandidateActivity(Object.values(response.data));
        console.log("Fetched Data:", response.data);
      }
    } catch (error) {
      toast.error("Error fetching candidate activity", {
                position: "top-right", 
                autoClose: 2000,
              });
      console.error("Error fetching candidate activity:", error);
    }
  };

  return (
    <section className="hiring-timeline" >
      <h6 className="hiring-heading mb-3">Hiring Timeline</h6>
        <ul className="position-relative">
          {candidateActivity && candidateActivity.map((activity, index) => {
            const className = activity.outcome === "Selected" ? "success" : activity.outcome === "Rejected" ? "rejected" : "success";
            return (
              <li className={`d-flex align-items-center gap-3 position-relative ${className}`} >
                <span>
                  {activity.outcome === "Selected" ? <GoCheck /> : activity.outcome === "Rejected" ? <CgClose /> : <LuMinus />}
                </span>
            <p className="mb-0">{activity.actionTaken}</p>
              </li>
            );
          })} 
          {/* <li className="d-flex align-items-center gap-3 position-relative">
            <span>
              <LuMinus />
            </span>
            <p className="mb-0">Onboarded</p>
          </li>
          <li className="d-flex align-items-center gap-3 position-relative">
            <span>
              <LuMinus />
            </span>
            <p className="mb-0">Offered</p>
          </li>
          <li className="d-flex align-items-center gap-3 position-relative">
            <span>
              <LuMinus />
            </span>
            <p className="mb-0">Interview - Client</p>
          </li>
          <li className="d-flex align-items-center gap-3 position-relative onhold">
            <span>
              <HiMiniPause />
            </span>
            <p className="mb-0">Interview - Manager</p>
          </li>
          <li className="d-flex align-items-center gap-3 position-relative rejected">
            <span>
              <CgClose />
            </span>
            <p className="mb-0">Interview - Manager</p>
          </li>
          <li className="d-flex align-items-center gap-3 position-relative success">
            <span>
              <GoCheck />
            </span>
            <p className="mb-0">Interview -  Technical</p>
          </li>
          <li className="d-flex align-items-center gap-3 position-relative success">
            <span>
              <GoCheck />
            </span>
            <p className="mb-0">Interview - HR</p>
          </li>
          <li className="d-flex align-items-center gap-3 position-relative success">
            <span>
              <GoCheck />
            </span>
            <p className="mb-0">Screening</p>
          </li>
          <li className="d-flex align-items-center gap-3 position-relative success">
            <span>
              <GoCheck />
            </span>
            <p className="mb-0">Applying</p>
          </li>
          <li className="d-flex align-items-center gap-3 position-relative success">
            <span>
              <GoCheck />
            </span>
            <p className="mb-0">Vacancy Announced</p>
          </li> */}
          <li className="d-flex align-items-center gap-3 position-relative success">
            <span>
              <GoCheck />
            </span>
            <p className="mb-0">Applying</p>
          </li>
          <li className="d-flex align-items-center gap-3 position-relative success">
            <span>
              <GoCheck />
            </span>
            <p className="mb-0">Vacancy Announced</p>
          </li> 
        </ul>
    </section>
  );
}

